import React, { useEffect } from "react";
import useStatus from "../../../../common-deprecated/hooks/useStatus";
import { useCompareV2Selector } from "../../redux/store";
import { useModalMap } from "../../../../common-deprecated/containers/ModalProvider";
import useInitNewCompare from "../../hooks/useInitNewCompare";
import AEMLexusCompareView from "./CompareV2View";
import useNcCompareTools from "../../hooks/useNcCompareTools";
import { aemLexusCompareModalMap } from "./modals/modals";
import { updateTrackingLayerVersioning } from "../../utils/tracking";

const CompareLexus = (): JSX.Element => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);

    useInitNewCompare();
    useModalMap(aemLexusCompareModalMap);
    const tools = useNcCompareTools();
    useStatus(commonSettings, "Compare V2", tools);

    useEffect(() => {
        updateTrackingLayerVersioning();
    }, []);

    return <AEMLexusCompareView />;
};

export default CompareLexus;
